import React from "react";
import { styled } from "@mui/material/styles";

import { Grid } from "../../UI/Grid";
import { Popper } from "../../UI/Popper";
import { Typography } from "../../UI/Typography";
import { COLOR_FIORD, COLOR_NILE_BLUE, COLOR_WHITE } from "../../constants/styles";

export type TooltipURL = {
  link: string;
  text: string;
}

interface IProps {
  title?: string;
  text?: string;
  customText?: React.ReactNode;
  customXs?: number;
  withIcon?: boolean;
  withIconAndChild?: boolean;
  className?: string;
  color?: "white" | "black";
  justifyContent?: string;
}

const StyledPopper = styled(Popper)`
  max-width: 322px;
  z-index: ${(props) => props.theme.zIndex.tooltip};
  padding: ${(props) => props.theme.spacing(2, 2.5)};
  background-color: ${COLOR_NILE_BLUE};
`;

const StyledTitleWrapper = styled(Grid)`
  border-bottom: 1px solid ${COLOR_FIORD};
  padding-bottom: 10px;
  margin-bottom: 10px;
`;
const StyledTitle = styled(Typography)`
  font-weight: 600 !important;
  font-size: 14px !important;
`;

const ICONS = {
  white: "/static/images/icons/question-white.svg",
  black: "/static/images/icons/question.svg",
};

export const HelpTooltip: React.FC<IProps> = (props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMouseLeave = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(null);
  };

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const text = <>
    <Grid item xs={12}>
      <Typography color={COLOR_WHITE} sx={{ fontSize: "14px !important" }}>
        {props.text}
      </Typography>
    </Grid>
  </>;

  return (
    <Grid container spacing={0.5} component="span" alignItems="center" onMouseLeave={handleMouseLeave} justifyContent={props.justifyContent}>
      <Grid item xs={props.customXs} onMouseEnter={props.withIcon && !props.withIconAndChild? undefined : handleMouseEnter}>
        {props.children}
      </Grid>

      <Grid item display="flex" alignItems="center" onMouseEnter={props.withIcon || props.withIconAndChild ? handleMouseEnter : undefined}>
        {(props.withIcon || props.withIconAndChild) && <img src={ICONS[props.color as "black"]} alt="" className={props.className} />}
        <StyledPopper placement="auto" anchorEl={anchorEl} open={Boolean(anchorEl)}>
          <Grid container>
            {props.title && (
              <StyledTitleWrapper item xs={12}>
                <StyledTitle color={COLOR_WHITE}>{props.title}</StyledTitle>
              </StyledTitleWrapper>
            )}
            {props.customText ? props.customText: text}
          </Grid>
        </StyledPopper>
      </Grid>
    </Grid>
  );
};

HelpTooltip.defaultProps = {
  color: "white",
  withIcon: true,
};
